/**
 * Shared client-side view of the platform (non-agency-scoped) roles.
 *
 * Mirrors PROBATION_GLOBAL_ROLES in apps/services/agencyAccess.js, which is
 * what `allowAllAgencies` — and therefore every server-side 403 — is actually
 * derived from. This module exists so the list is named once on the client
 * instead of a third time: AccessSummary already labelled these three roles,
 * and the Submissions nav gate would have been copy number three.
 *
 * Client-side use is cosmetic. The server is the control.
 */

export const PROBATION_GLOBAL_ROLES = ['super_admin', 'probation_admin', 'probation_viewer'];

export const GLOBAL_ROLE_LABELS = {
  super_admin: 'Platform Super Admin',
  probation_admin: 'Probation Admin',
  probation_viewer: 'Probation Viewer',
};

/**
 * Does this user see county-wide (Probation-level) data?
 *
 * @param {string[]} [globalRoles] user.global_roles from the session/context payload
 * @param {boolean}  [isSuperuser] user.is_superuser
 * @returns {boolean}
 */
export function isProbationUser(globalRoles = [], isSuperuser = false) {
  if (isSuperuser) {
    return true;
  }
  return Array.isArray(globalRoles)
    && globalRoles.some(role => PROBATION_GLOBAL_ROLES.includes(role));
}
